import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import PropTypes from 'prop-types';

let temp = [
{
  "label": "Available",
  "amount": 0,
},
{
  "label": "Collateralized",
  "amount": 0,
},
{
  "label": "Spending",
  "amount": 0,
},
{
  "label": "Unlockable",
  "amount": 0
}
]

class Balance extends Component {
  static contextTypes = {
    router: PropTypes.object
  };
  constructor(){
    super();
    this.state = {nrg: 0,spending:0,nrg_collateralized:0};
  }
  componentDidUpdate(props){
    let {nrg,nrg_collateralized,spending} = this.props;
    if(nrg !== this.state.nrg || nrg_collateralized !== this.state.nrg_collateralized || spending !== this.state.spending){
      this.setState({nrg,nrg_collateralized,spending});
      this.updateChart();
    }
  }
  updateChart(){
    let available = this.props.spending > 0 ? Math.max(0,this.props.nrg - this.props.spending) : Math.max(1,this.props.nrg);
    if(this.props.spending == 0 && this.props.nrg_collateralized) available = Math.max(0,this.props.nrg)
    this.chart.data = [
    {
      "label": "Available",
      "amount": available,
      "amountReal": this.props.nrg - this.props.spending
    },
    {
      "label": "Collateralized",
      "amount": Math.max(0,this.props.nrg_collateralized),
      "amountReal": this.props.nrg_collateralized
    },
    {
      "label": "Spending",
      "amount": Math.max(0,this.props.spending),
      "amountReal": this.props.spending
    },
    {
      "label": "Unlockable",
      "amount": Math.max(0,this.props.unlockable),
      "amountReal": this.props.unlockable
    }

    ];
  }
  returnData(){
    let colors = [
      am4core.color("#2a79ff"),
      am4core.color("#2a79ff").lighten(0.3),
      am4core.color("#2a79ff").lighten(0.5),
      am4core.color("#2a79ff").lighten(0.7),
    ]
    let map = this.chart && this.chart.data ? this.chart.data : temp;
    return map.map(({label,amount},i)=>{
      return <div className='col s12' style={{padding:0}}>
        <p className='nrgdata'>
          <div className='nrg_box' style={{background:colors[i].hex}}></div>
          <span style={{opacity:0.7}}>{label}: </span> <br/>
          <span>{amount}</span> <br/>
          <span style={{color:'grey'}}>(${amount})</span>
        </p>
      </div>
    })
  }
  initiateChart(){
    let chart = am4core.create("nrgdiv", am4charts.PieChart);

    // Add and configure Series
    chart.innerRadius = am4core.percent(50);
    let pieSeries = chart.series.push(new am4charts.PieSeries());
    pieSeries.dataFields.value = "amount";
    pieSeries.dataFields.category = "label";
    pieSeries.dataFields.amountReal = 'amountReal';
    pieSeries.labels.template.disabled = true;
    pieSeries.ticks.template.disabled = true;
    pieSeries.slices.template.tooltipText = "";
    var hs = pieSeries.slices.template.states.getKey("hover");
    hs.properties.scale = 1;
    this.chart = chart;

    pieSeries.colors.list = [
      am4core.color("#2a79ff"),
      am4core.color("#2a79ff").lighten(0.3),
      am4core.color("#2a79ff").lighten(0.5),
      am4core.color("#2a79ff").lighten(0.7),
    ];

    this.updateChart()
  }
  componentDidMount(){
    let _this = this;
    this.initiateChart();
  }
  render() {
    return (
      <div className='col s12' style={{padding:0}}>
        <p className='nrgStats'> 1 NRG = 1 DAI = $1.00</p>
        <div className='col s6 center' style={{padding:0}}>
          <h5 className='center white-text' style={{marginBottom:0,padding:0}}>NRG</h5>
          <div className='nrgdiv' id="nrgdiv" style={{maxWidth:'100%',height:'190px',marginTop:'-10px'}}> </div>
        </div>
        <div id='nrgDataItems' className='col s6' style={{marginTop:'10px'}}>
          {this.returnData.bind(this)()}
        </div>
      </div>
    );
  }
}



function mapStateToProps(state,props) {
  return {
    nrg: state.passport.nrg,
    nrg_collateralized: state.passport.nrg_collateralized,
    unlockable: state.passport.unlockable,
    spending: state.ui_marketplace.spending
  };
}

export default connect(mapStateToProps,{})(Balance);
